import { render, staticRenderFns } from "./customer-setting.vue?vue&type=template&id=45d14ca0&scoped=true&"
import script from "./customer-setting.vue?vue&type=script&lang=js&"
export * from "./customer-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d14ca0",
  null
  
)

export default component.exports